import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { featureFlagResolver } from 'feature-flag';
import { BaseLangGuard, langUrlMatcher } from 'language';
import { LoadingComponent } from 'loading';
import { prismicPreviewGuard } from 'prismic';
import { RedirectService } from 'redirect';
import { BrowserService } from 'utils';
import { BaseComponent } from './pages/base/base.component';
import { DummyComponent } from './pages/dummy/dummy.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./auth/auth.routes').then(m => m.routes) },
  {
    path: '',
    loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
  },
];

export const appRoutes: Routes = [
  {
    path: 'kitsune-preview',
    component: LoadingComponent,
    canActivate: [prismicPreviewGuard({ homeUID: 'home', resolveBy: 'uid' })],
  },
  {
    path: 'u/:token',
    canActivate: [
      route =>
        inject(RedirectService).redirectTo(
          inject(BrowserService).getOrigin() + '/ms/gdpr/unsubscribe?logintoken=' + route.params['token']
        ),
    ],
    component: DummyComponent,
  },
  {
    matcher: langUrlMatcher,
    component: BaseComponent,
    resolve: { featureFlags: featureFlagResolver },
    children: routes,
  },
  {
    path: '**',
    component: DummyComponent,
    canActivate: [BaseLangGuard],
  },
];
